import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { searchType } from "../utils/types";
const initialState: searchType = {
  allDoctorList: [],
  p_snomed_concept_code: "",
  autoSuggestions: [],
  loader: "",
  autoSuggestionPayload: {
    type: "",
    value: "",
  },
  recommendedList: [],
  not_recommendedList: [],
  seeMore: false,
  healthneed: "",
  isMobile: false,
  customContainerstyle: {},
  searchPayload: {},
  cancenterList: [],
  seeMoreCancenter: false,
  isCancerAckMsgAckedonMobilescreen: false,
  isShowCancerModal: true,
  isCancerSelectedinSearchCriteria: false,
  selectedDoctor: {},
  allRecommendedList: [],
  allNot_recommendedList: [],
  allTrackingInput:{},
  noRecordsFound: false,
  formDataPayload: {
    zipCode: [],
    specialty: [],
    patientType: "",
    referredDoctors: [],
    isAlreadyDiagnosed: undefined,
  },
  refredDoctorList: [],
  selectedOption: {},
 
  isMailSendFooter: false,
  isRequestStarted: false,
  allBenefitDetails:[],
  filterCountValue: 0,
  filterCount: 0,
  gender: [],
  includeOutOfNetwork: false,
  languages: [],

  userLocation: null,
  freshFetchDoctors:false,
  isPhoneNumberEnter: false,
  popUpHealthNeed: null,
};
const searchSlice = createSlice({
  name: "search",
  initialState,
  reducers: {
    setAutoSeggestion: (
      state,
      action: PayloadAction<searchType["autoSuggestions"]>
    ) => {
      state.autoSuggestions = action.payload;
    },
    setrefredDoctorList: (state, action) => {
      state.refredDoctorList = action.payload;
    },
    setSelectedOption: (state, action) => {
      state.selectedOption = action.payload;
    },
    setfreshFetchDoctors: (state, action) => {
      state.freshFetchDoctors = action.payload;
    },
   

    resetAutosuggestion: (state) => {
      state.autoSuggestions = [];
    },
    setLoader: (state, action: PayloadAction<searchType["loader"]>) => {
      state.loader = action.payload;
    },
    setAutoSuggestionpayload: (
      state,
      action: PayloadAction<searchType["autoSuggestionPayload"]>
    ) => {
      state.autoSuggestionPayload = action.payload;
    },
    resetAutoSuggestionpayload: (state) => {
      state.autoSuggestionPayload = {
        type: "",
        value: "",
      };
    },
    setRecommendedDoctorsList: (state, action) => {
      state.recommendedList = action.payload;
    },
    setAllTrackingInput: (state, action) => {
      state.allTrackingInput = action.payload;
    },
    setNoRecordsFound: (state, action) => {
      state.noRecordsFound = action.payload;
    },
    setnotRecommendedDoctorsList: (state, action) => {
      state.not_recommendedList = action.payload;
    },
    setAllRecommendedDoctorsList: (state, action) => {
      state.allRecommendedList = action.payload;
    },
    setAllNonRecommendedDoctorsList: (state, action) => {
      state.allNot_recommendedList = action.payload;
    },
    setToogleSeeMore: (state, action: PayloadAction<boolean>) => {
      state.seeMore = action.payload;
    },
    setHealthneed: (state, action) => {
      state.healthneed = action.payload;
    },
    setIsMobile: (state, action) => {
      state.isMobile = action.payload;
    },
    setp_snomed_concept_code: (state, action) => {
      state.p_snomed_concept_code = action.payload;
    },
    setCustomContainerstyle: (state, action) => {
      state.customContainerstyle = action.payload;
    },
    setSearchPayload: (state, action) => {
      state.searchPayload = action.payload;
    },
    setCancenterList: (state, action) => {
      state.cancenterList = action.payload;
    },
    setformDataPayload: (state, action) => {
      state.formDataPayload = action.payload;
    },
    setselectedDoctor: (state, action) => {
      state.selectedDoctor = action.payload;
    },
    setAllDoctorList: (state, action) => {
      state.allDoctorList = action.payload;
    },
    setSeeMoreCancenter: (state, action: PayloadAction<boolean>) => {
      state.seeMoreCancenter = action.payload;
    },
    setIsCancerAckMsgAckedonMobilescreen: (
      state,
      action: PayloadAction<boolean>
    ) => {
      state.isCancerAckMsgAckedonMobilescreen = action.payload;
    },
    setIsShowCancerModal: (state, action: PayloadAction<boolean>) => {
      state.isShowCancerModal = action.payload;
    },
    setIsCancerSelectedinSearchCriteria: (
      state,
      action: PayloadAction<boolean>
    ) => {
      state.isCancerSelectedinSearchCriteria = action.payload;
    },
    setIsMailSendFooter: (state, action) => {
      state.isMailSendFooter = action.payload;
    },
    setIsRequestStarted: (state, action: PayloadAction<boolean>) => {
      state.isRequestStarted = action.payload;
    },
    setAllBenefitDetails: (state, action) => {
      state.allBenefitDetails = action.payload;
    },
    setFilterCountValue :(state, action) => {
      state.filterCountValue = action.payload;
    },
      setFilterData: (state, action) => {
        console.log(action)
      const { count, gender, includeOutOfNetwork, languages } = action.payload;
      state.filterCount = count;
      state.gender = action.payload.data.gender;
      state.includeOutOfNetwork = action.payload.data.includeOutOfNetwork;
      state.languages = action.payload.data.languages;
    },

    setUserLocation: (
      state,
      action: PayloadAction<{ latitude: number; longitude: number }>
    ) => {
      state.userLocation = action.payload;
    },
    setIsPhoneNumberEntered: (state, action) => {
      state.isPhoneNumberEnter = action.payload;
    },
    setPopUpHealthNeed: (state, action) => {
      state.popUpHealthNeed = action.payload;
    },

    reset: () => initialState,
  },
});
export const searchAction = searchSlice.actions;
export default searchSlice.reducer;
